package org.example.willfreightnew

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.ColorPalettes
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

/**
 * @property nearBackground A useful color to apply to a container that should differentiate itself from the background
 *   but just a little.
 */
class SitePalette(
    val whiteText: Color,
    val background: Color,
    val nearBackground: Color,
    val contrastBackground: Color,
    val brand: Brand,
    val faint: Color,
    val faintText: Color
) {
    class Brand(
        val primary: Color = Color.rgb(0xD41011),
        val accent: Color = Color.rgb(175, 0, 0)
    )
}

object SitePalettes {
    val light = SitePalette(
        whiteText = Colors.White,
        faint = ColorPalettes.Monochrome._100,
        background = Color.rgb(0xFFFFFF),
        nearBackground = ColorPalettes.Monochrome._50,
        contrastBackground = ColorPalettes.Monochrome._900,
        faintText = ColorPalettes.Monochrome._500,
        brand = SitePalette.Brand(
            primary = Color.rgb(0x000000),
            accent = Colors.Red,
        )
    )
    val dark = SitePalette(
        whiteText = Colors.White,
        faint = ColorPalettes.Monochrome._700,
        background = Color.rgb(0x131516),
        nearBackground = Color.rgb(0x262A2B),
        contrastBackground = Color.rgb(0x080808),
        faintText = ColorPalettes.Monochrome._300,
        brand = SitePalette.Brand(
            primary = Color.rgb(0xFFFFFF),
            accent = Color.rgb(0xD41011),
        )
    )
}

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.LIGHT -> SitePalettes.light
        ColorMode.DARK -> SitePalettes.dark
    }
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = Color.rgb(0xFAFAFA)
    ctx.theme.palettes.light.color = Colors.Black
    ctx.theme.palettes.dark.background = Color.rgb(0x06080B)
    ctx.theme.palettes.dark.color = Colors.White
}


